import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import { inviteUsers } from "../../common/tenantApi";
import { trackEvent } from "../../hooks/useTrackEvent";
import { finalizeOnboardingSubmission } from "./PendingApprovalPage";

export default function StepEquipo() {
  const navigate = useNavigate();
  const tenantId = sessionStorage.getItem("onboarding_tenant_id");
  const [rows, setRows] = useState([{ email: "", role: "editor" }]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!tenantId) {
      navigate("/onboarding/workspace", { replace: true });
      return;
    }
    if (sessionStorage.getItem("onboarding_contact_done") !== "true") {
      navigate("/onboarding/contacto", { replace: true });
    }
  }, [tenantId, navigate]);

  const addRow = () => {
    if (rows.length < 10) setRows([...rows, { email: "", role: "reader" }]);
  };

  const finishOnboarding = async ({ skippedTeam = false, teamCount = 0 } = {}) => {
    if (skippedTeam) {
      trackEvent("onboarding_step_4_team_skipped", {
        event_category: "onboarding",
        event_label: "team_step_skipped",
        step_number: 4,
        tenant_id: tenantId,
      });
    } else {
      trackEvent("onboarding_step_4_team_added", {
        event_category: "onboarding",
        event_label: "team_members_added",
        step_number: 4,
        tenant_id: tenantId,
        team_count: teamCount,
      });
    }
    await finalizeOnboardingSubmission(navigate);
  };

  const handleSkip = async () => {
    setLoading(true);
    setError("");
    try {
      await finishOnboarding({ skippedTeam: true });
    } catch (e) {
      setError(e.message || "No se pudo enviar la solicitud");
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");
    try {
      const invitations = rows.filter((r) => r.email.trim());
      if (tenantId && invitations.length) {
        await inviteUsers(tenantId, invitations);
      }
      await finishOnboarding({
        skippedTeam: false,
        teamCount: invitations.length,
      });
    } catch (e) {
      setError(e.message || "No se pudo enviar la solicitud");
      setLoading(false);
    }
  };

  return (
    <>
      <div className="ob-card-header">
        <div className="ob-step-icon">
          <GroupOutlinedIcon sx={{ fontSize: 24 }} />
        </div>
        <div className="ob-card-header-text">
          <h2 className="ob-step-title">Invitá a tu equipo</h2>
          <p className="ob-step-desc">Opcional — podés invitar colaboradores más tarde.</p>
        </div>
      </div>

      <div className="ob-invite-list">
        {rows.map((row, idx) => (
          <div className="ob-invite-row" key={idx}>
            <input
              type="email"
              placeholder="colega@empresa.com"
              value={row.email}
              onChange={(e) => {
                const next = [...rows];
                next[idx] = { ...next[idx], email: e.target.value };
                setRows(next);
              }}
            />
            <select
              value={row.role}
              onChange={(e) => {
                const next = [...rows];
                next[idx] = { ...next[idx], role: e.target.value };
                setRows(next);
              }}
            >
              <option value="editor">Editor</option>
              <option value="reader">Lector</option>
            </select>
          </div>
        ))}
      </div>

      <button className="ob-invite-add" type="button" onClick={addRow}>
        + Agregar otro
      </button>

      {error && <p className="ob-error">{error}</p>}

      <button className="ob-btn-primary" onClick={handleSubmit} disabled={loading} type="button">
        {loading ? "Enviando solicitud..." : "Enviar solicitud"}
      </button>
      <button className="ob-btn-secondary" onClick={handleSkip} disabled={loading} type="button">
        Saltear por ahora
      </button>
    </>
  );
}
